<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<!-- Labour Count window -->
<div #container [hidden]="isHidden$ | async" class="labour-count-container">
	<!-- This element contains the crew sizes and filter elements. It is visible when the user is zoomed in enough to see data -->
	<div [hidden]="!(zoomtextHidden$ | async)">
		<!-- This is the main render area for the Labour count chart -->
		<div class="labour-count-render-area">
			<canvas #canvasChart class="labour-count-canvas"></canvas>
		</div>
	</div>

	<!-- MOC-3150 -->
	<div [hidden]="!(zoomtextHidden$ | async)" class="labour-count-filter-area explicit-interactable">
		<multi-role-select
			[roleList$]="planState.rolesApi.data.list$"
			[selectedRolesIds]="selectedRolesIds$ | async"
			(roleChanged)="filterChanged($event)"
			class="small-font"
		></multi-role-select>
	</div>

	<!-- Close Button -->
	<div class="labor-count-button-position explicit-interactable">
		<button class="legacy-button labor-count-button-theme" (click)="closeClicked()">
			<i class="material-icons notranslate" automationId="close">close</i>
		</button>
	</div>

	<!-- This element contains the zoom in message. It is visible when the user is zoomed out and cannot see data in the crew sizes graph -->
	<div [hidden]="zoomtextHidden$ | async">
		<span class="zoom-in-message">
			{{ zoomInMessage }}
		</span>
	</div>
</div>
